module.exports = __webpack_public_path__ + "bootleggers_coffee_logo.jpg?f7a3ec8ff8417591c5895dee190eaecd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_logo.jpg
// module id = 38
// module chunks = 0